module.exports = __webpack_public_path__ + "img/ben_pursche_signature.000f119f.png";